define([
    "./templateFactoryModule",
    "./templateFactoryMapper",
    "./templateFactoryService"
],function(){
});